import type { Assignment } from '@/types/Models/Assignment'
import type { ComputedRef } from 'vue'
import { computed } from 'vue'
import { LABELS_CREATING, LABELS_RELEASED, REPORT_RELEASED } from '@/const/AssignmentStatuses'
import { StatusColor } from '@/services/Status/StatusColor'
import { StatusName } from '@/services/Status/StatusName'
import moment from 'moment'

export const useAssignmentStatus = (assignment: ComputedRef<Assignment>) => {
  const labelsDownloaded = computed(
    () =>
      [LABELS_RELEASED, LABELS_CREATING, REPORT_RELEASED].includes(assignment.value.status) &&
      assignment.value.labelsDownloadedAt,
  )
  const statusName = computed(() =>
    labelsDownloaded.value
      ? `Labels Downloaded at ${moment(assignment.value.labelsDownloadedAt).format('YYYY-MM-DD HH:mm')}`
      : StatusName[assignment.value.type][assignment.value.status],
  )

  const statusShortName = computed(() =>
    (statusName.value?.split(' ').slice(0, 2) || []).map((word: string) => word.charAt(0).toUpperCase()).join(''),
  )

  const statusColor = computed(() => (labelsDownloaded.value ? '#058880' : StatusColor[assignment.value.status]))

  const circleStyle = computed(() => ({ color: statusColor.value, lineHeight: '1' }))

  return {
    statusName,
    statusShortName,
    circleStyle,
  }
}
